const download = function (file, blob) {
    const element = document.createElement('a');
    const downloadUrl = window.URL.createObjectURL(blob);
    element.href = downloadUrl;
    element.download = file;
    document.body.appendChild(element);
    element.click();

    document.body.removeChild(element);
    window.URL.revokeObjectURL(downloadUrl);
}
function jsonToCsv(header, json, keys = null) {
    if (!keys) keys = header.map(h => h.toLowerCase().replace(' ', '_').replace('-', '_'));
    const csvRows = [];

    // Add header row
    csvRows.push(header.join(','));

    // Iterate over each record and format it as CSV
    for (let i = 0; i < json.length; i++) {
        const item = json[i];
        const row = keys.map(key => {
            // Escape quotes and commas in data to prevent CSV issues
            return `"${item[key] ? item[key].toString().replace(/"/g, '""') : ''}"`;
        }).join(',');
        csvRows.push(row);
    }

    // Return the complete CSV as a string
    return csvRows.join('\n');
}
module.exports = {
    runApiRequest(url, action, commit) {
        return axios
            .get(url)
            .then(function (response) {
                commit(action, response.data);
            })
            .catch(function (error) {
                throw new Error(`API ${error}`);
            });
    },

    attachConfirmEventBeforeUnload(msg) {
        window.onbeforeunload = function (e) {
            e = e || window.event;
            // For IE and Firefox
            if (e) {
                e.returnValue = msg;
            }
            // For Safari
            return msg;
        };
    },
    detachConfirmEventBeforeUnload() {
        window.onbeforeunload = function () { };
    },
    download,
    jsonToCsv,
    exportShiurim(form, type, lecturer_id) {
        axios.post('/api/admin/shiurim-by-ids', { 'type': type, lecturer_id: lecturer_id }).then(response => {
            const csvContent = jsonToCsv(response.data.header, response.data.data);
            // Add BOM for UTF-8 (to handle Hebrew characters correctly in Excel)
            download('shiurim-ids.csv', new Blob(['\ufeff' + csvContent], {type: 'text/csv; charset=UTF-8'}));
        });
    },
    copyToClipboard(textToCopy, message = 'Text copied successfully.') {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard api method'
            return navigator.clipboard.writeText(textToCopy).then(() => {
                alert(message)
            });
        } else {
            // text area method
            let textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej) => {
                // here the magic happens
                document.execCommand('copy') ? res() : rej();
                textArea.remove();
                alert(message)
            });
        }
    },
    shiur_length_to_seconds(time) {
        time = time.split(':').reverse().map(m => parseInt(m));
        return time[0] + (time[1] ? time[1] * 60 : 0) + (time[2] ? time[2] * 3600 : 0);
    }
};
